import { Component, OnInit, OnDestroy } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { NgxSpinnerService } from 'ngx-spinner'
import { filter } from 'rxjs/operators'

import { SiteService } from './services/site.service'
import { MessageService } from './services/message.service'

declare let gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy
{
  title = 'customerportal-web'

  nextConfig: any
	isBusy: boolean = false
	requestStartedSubscription: Subscription
	requestCompletedSubscription: Subscription
	asyncRequests: string[] = []

  constructor(
    private router: Router,
    private siteService: SiteService,
    private messageService: MessageService,
    private ngxSpinnerService: NgxSpinnerService,
    public translateService: TranslateService
	)
  {
    this.requestStartedSubscription = this.messageService.httpRequestStarted$.subscribe(route =>
    {
      this.asyncRequests.push(route)
      this.isBusy = true
      this.ngxSpinnerService.show()
    })

    this.requestCompletedSubscription = this.messageService.httpRequestCompleted$.subscribe(route =>
    {
      this.asyncRequests.splice(this.asyncRequests.indexOf(route), 1)
      if (this.asyncRequests.length === 0)
      {
        this.isBusy = false
        this.ngxSpinnerService.hide()
      }
    })

    this.router.events.subscribe((evt) =>
    {
      //this.siteService.killChat()

      if (!(evt instanceof NavigationEnd))
      {
        return;
      }
      window.scrollTo(0, 0)
    })

    // // @ts-ignore
    // window.customPlugin.subscribe('WebChat.opened', function (e) 
    // {
    //   sessionStorage.setItem('AlreadyShow','Already Shown')
    //   document.getElementById("footerChat").style.display = "none"
    //   console.log('Chat open', e)
    // })

    // // @ts-ignore
    // window.customPlugin.subscribe('WebChat.closed', function (e) 
    // {
    //   document.getElementById("footerChat").style.display = "block"
    //   console.log('Chat closed', e)
    // }) 
  }

	ngOnInit()
	{
    this.setUpAnalytics()
    //this.startChat()
	}

  setUpAnalytics()
  {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      gtag('config', 'G-5P1TZ3T75C', {
        page_path: event.urlAfterRedirects
      });
    });
  }

  // startChat()
	// {
	// 	try
	// 	{
	// 		var chat_shown = sessionStorage.getItem('AlreadyShow')
      
  //     if(chat_shown!='Already Shown')
  //     {
  //       this.siteService
  //         .getChatAvailability()
  //         .subscribe({
  //           next: (apiResponse) =>
  //           {
  //             if (apiResponse)
  //             {
  //               document.getElementById("footerChat").style.display = "none"
              
  //               let chatDelay=10000;
  //               setTimeout(()=>
  //               {
  //                 // @ts-ignore
  //                 window.customPlugin.command('WebChat.open',configureChat(this.translateService.currentLang,'','','','',''))
  //                 sessionStorage.setItem('AlreadyShow','Already Shown')
  //               }, chatDelay)
  //             }         
  //           },
  //           error: (error) =>
  //           {
  //           },
  //           complete: () =>
  //           {
  //           }
  //         })      
  //     }
	// 	}
	// 	catch {}
	// }

  ngOnDestroy(): void
	{
		this.requestStartedSubscription.unsubscribe()
		this.requestCompletedSubscription.unsubscribe()
	}
}
